import { useNavigate } from 'react-router';
import { startTransition } from 'react';

import { Button } from 'src/components/ui/button';
import { ErrorHero } from 'src/components/ui/error-hero';
import env from 'env';

const ErrorBoundary = () => {
  const navigate = useNavigate();

  const onGoHome = () => startTransition(() => navigate('/'));

  const onContactSupport = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`);

  return (
    <div className="min-h-screen flex items-center justify-center py-10 px-6">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 items-center gap-8 md:gap-16">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-3xl md:text-5xl font-bold text-foreground md:leading-14">
                Sorry! We&apos;re having trouble loading this page right now.
              </h1>
              <p className="text-muted-foreground text-base md:text-lg">
                Please try refreshing the page, or head back to the home page.
              </p>
            </div>
            <div className="flex gap-3">
              <Button variant="default" size="lg" onClick={onGoHome}>
                Go back home
              </Button>
              <Button variant="secondary" size="lg" onClick={onContactSupport}>
                Contact support
              </Button>
            </div>
          </div>
          <ErrorHero headerTitle="Couldn’t load the page" />
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
